import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=none
  const [settings, setSettings] = useState({ product_name: "HouseSpend", currency: "£" });

  const loadSettings = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (_) {}
  };

  useEffect(() => {
    const token = localStorage.getItem("hs_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then(({ data }) => { setUser(data); loadSettings(); })
      .catch(() => { localStorage.removeItem("hs_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hs_token", data.token);
    setUser(data.user);
    loadSettings();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("hs_token");
    setUser(false);
  };

  const isAdmin = user && user.role === "admin";
  const isManager = user && (user.role === "admin" || user.role === "manager");
  const isStaff = user && user.role === "staff";

  return (
    <AuthCtx.Provider value={{ user, setUser, settings, setSettings, loadSettings, login, logout, isAdmin, isManager, isStaff }}>
      {children}
    </AuthCtx.Provider>
  );
}
